import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forumApi } from '../../lib/api';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Loader2, MessagesSquare, ArrowRight } from 'lucide-react';

export default function ForumHomePage() {
  const navigate = useNavigate();
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    forumApi.listCategories().then(({ data }) => setCats(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 max-w-5xl" data-testid="forum-home-page">
      <div>
        <h1 className="text-3xl font-bold text-[#0A2342] flex items-center gap-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
          <MessagesSquare className="w-7 h-7 text-[#0E7490]" />Community Forum
        </h1>
        <p className="text-[#64748B] mt-1">Ask questions, share wins, and connect with peers.</p>
      </div>

      {loading ? <Loader2 className="w-8 h-8 animate-spin text-[#0E7490]" /> : (
        <div className="space-y-2">
          {cats.map(c => (
            <Card key={c.id} className="careiq-card hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate(`/forum/c/${c.id}`)} data-testid={`forum-cat-${c.id}`}>
              <CardContent className="p-4 flex items-center justify-between gap-4">
                <div className="flex items-center gap-4 flex-1 min-w-0">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${c.color || '#0E7490'}20`, color: c.color || '#0E7490' }}>
                    <MessagesSquare className="w-6 h-6" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-[#0A2342]">{c.name}</div>
                    <div className="text-xs text-[#64748B] truncate">{c.description || 'Discuss anything in this space.'}</div>
                  </div>
                </div>
                <div className="text-right text-xs text-[#64748B] hidden md:block">
                  <div className="font-semibold text-[#0A2342]">{c.thread_count}</div>
                  <div>thread{c.thread_count !== 1 ? 's' : ''}</div>
                </div>
                <div className="text-right text-xs text-[#64748B] hidden md:block min-w-[120px]">
                  {c.last_thread_title ? (
                    <>
                      <div className="text-[#0A2342] truncate font-medium" title={c.last_thread_title}>{c.last_thread_title}</div>
                      <div>{c.last_post_at ? new Date(c.last_post_at).toLocaleDateString() : '—'}</div>
                    </>
                  ) : <span className="italic">No threads yet</span>}
                </div>
                <ArrowRight className="w-4 h-4 text-[#94A3B8] flex-shrink-0" />
              </CardContent>
            </Card>
          ))}
          {cats.length === 0 && <Card className="careiq-card"><CardContent className="p-10 text-center text-[#64748B]">No categories yet — check back soon.</CardContent></Card>}
        </div>
      )}
    </div>
  );
}
